import Vue from 'vue'

import { ValidationProvider, extend } from 'vee-validate'
// import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm';
import { ValidationObserver, setInteractionMode } from 'vee-validate'

import PhoneNumber from 'awesome-phonenumber'
import { required, email, alpha_num, alpha_spaces, numeric, min, alpha, max, size, image, length, confirmed } from 'vee-validate/dist/rules'
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

setInteractionMode('eager')

extend('confirmed', {
  ...confirmed,
  message: 'Password does not match'
})

extend('name', {
  ...alpha_spaces,
  message: 'Please enter a valid name'
})
extend('length', {
  ...length,
  message: 'Enter a valid 16 digit number',
  validate: value => {
    return value.length == 16
  },
})
extend('alpha_num', {
  ...alpha_num,
  message: 'Only alphabet and numbers allowed',
})
extend('maxFileSize', {
  ...size,
  message: 'max size 2MB exceeded',
  validate: value => {
    const kbValue = value.size / 1000
    return kbValue < 2000
  },
})
extend('required', {
  ...required,
  message: 'This field is required',
}
,
)
extend('image', {
  ...image,
  message: 'File type must be an image',
})
extend('alpha', {
  ...alpha,
})
extend('min', {
  ...min,
  message: 'Enter Value greate than one',
  validate: value => {
    return value > 0
  },
})
extend('maxInterest', {
  ...max,
  message: 'Enter Value less than 100',
  validate: value => {
    return value < 100
  },
})
extend('maxRequestAmount', {
  ...max,
  message: 'Maximum amount is 20,00,000',
  validate: value => {
    return value < 2000001
  },
})

extend('minRequestAmt', {
  ...min,
  message: 'Minimum amount is Rs 1',
  validate: value => {
    return value > 0
},
})

extend('minInterest', {
  ...min,
  message: 'Enter Value greate than zero',
  validate: value => {
    return value > 0
  },
})
extend('minTermLoan', {
  ...min,
  message: 'Enter Value greate than 0',
  validate: value => {
    return value > 0
  },
})
extend('numeric', {
  ...numeric,
  message: 'Only numbers is accepted',
})
extend('phone', {
  message () {
      return `Please enter a valid phone number`
  },
  validate (value) {
      return new Promise(resolve => {
          const phone = new PhoneNumber(value, 'NP')
          resolve({ valid: phone.isValid() })
      })
  },
})
extend('email', {
  ...email,
  message: 'Please enter valid email',
})

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match',
})
